export default (id, defaultTab) => ({
  tab: defaultTab,
  id: id,
  selectTab(value) {
    this.tab = value;
    this.$dispatch("tab-selected", { id: this.id, value: value });
  },
});
